<app-z-dialog
  [title]="(step() === 'crop' ? 'HEADER.USER_MENU.CROP_TITLE' : 'HEADER.USER_MENU.CAMERA_TITLE') | translate"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <div class="camera-capture">
    @if (step() === 'camera') {
      <div class="camera-stage">
        @if (initializing()) {
          <div class="camera-loading">
            <mat-spinner diameter="40"></mat-spinner>
            <span>{{ 'HEADER.USER_MENU.CAMERA_STARTING' | translate }}</span>
          </div>
        }
        <video
          #videoEl
          class="camera-video"
          playsinline
          muted
          autoplay
        ></video>
      </div>
    } @else {
      <div class="crop-stage">
        <canvas
          #cropCanvasEl
          class="crop-canvas"
          (pointerdown)="onPointerDown($event)"
          (pointermove)="onPointerMove($event)"
          (pointerup)="onPointerUp($event)"
          (pointercancel)="onPointerUp($event)"
        ></canvas>
      </div>
      <div class="crop-controls">
        <mat-icon>zoom_out</mat-icon>
        <input
          type="range"
          class="zoom-slider"
          [min]="minZoom()"
          [max]="maxZoom()"
          step="0.01"
          [value]="zoom()"
          (input)="onZoomChange($event)"
        />
        <mat-icon>zoom_in</mat-icon>
      </div>
      <p class="crop-hint">{{ 'HEADER.USER_MENU.CROP_HINT' | translate }}</p>
    }
  </div>
</ng-template>

<ng-template #buttonsTemplate>
  @if (step() === 'camera') {
    <z-button
      [label]="'HEADER.USER_MENU.CAMERA_CAPTURE' | translate"
      icon="photo_camera"
      color="primary"
      [disabled]="initializing()"
      (clicked)="capture()"
    ></z-button>
  } @else {
    <z-button
      [label]="'HEADER.USER_MENU.CAMERA_RETAKE' | translate"
      icon="refresh"
      matType="stroked"
      color="primary"
      (clicked)="retake()"
    ></z-button>
    <z-button
      [label]="'HEADER.USER_MENU.CAMERA_USE_PHOTO' | translate"
      icon="check"
      color="primary"
      (clicked)="confirm()"
    ></z-button>
  }
</ng-template>
